<template>
  <div class="box_card_wrapper">
    <div class="box_wrapper">
      <img :src="getIcon" />
      <p class="box_title">{{ title }}</p>
    </div>
    <el-card class="box_card">
      <slot />
    </el-card>
  </div>
</template>

<script>
import section1Svg from "./icons/section1.svg";
import section2Svg from "./icons/section2.svg";
import section3Svg from "./icons/section3.svg";
import section4Svg from "./icons/section4.svg";

export default {
  props: ["title", "sectionId"],
  computed: {
    getIcon() {
      if (this.sectionId == 1) {
        return section1Svg;
      }
      if (this.sectionId == 2) {
        return section2Svg;
      }
      if (this.sectionId == 3) {
        return section3Svg;
      }
      if (this.sectionId == 4) {
        return section4Svg;
      }
    },
  },
};
</script>

<style scoped>
.box_card_wrapper {
  margin: 2.5rem 1.2rem;
}

.box_card {
  height: 180px;
  border-radius: 12px !important;
  overflow: auto;
}

.box_title {
  margin-left: 10px;
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  color: #333333;
}
.box_wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-left: 10px;
}
</style>
